import React from 'react';
import GallaryEventGoonj2026 from '../views/Goonj2026/components/GallaryEventGoonj2026';

const AccountGeneralPage = () => {
  return <GallaryEventGoonj2026/>;
};

export default AccountGeneralPage;
